import React, { Suspense, lazy } from 'react';
import Header from './Header';
import Footer from './Footer';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './../App.css';
import { Outlet } from 'react-router-dom';

const NavbarComponent = lazy(() => import('./NavBar/NavbarComponent'));
const Sidebar = lazy(() => import('./SideBar/SideBar'));

const LandingPage = () => {
  return (
      <div className="app">
        <Suspense fallback={<div className="app-loading">Loading...</div>}>
        {/* <NavbarComponent /> */}
        </Suspense>

    <div className="app-body">
      <div className="app-sidebar-wrap">
                <Suspense fallback={<div className="app-loading">Loading...</div>}><Sidebar/></Suspense>
            </div>
      <div className="app-main-wrap main-height">
                <Suspense fallback={<div className="app-loading">Loading...</div>}><outlet/></Suspense><Outlet/>
                <Footer/>
            </div>
        </div>
      </div>
  );
}

export default LandingPage;
